import Cards from "@/assets/comman/Cards";
import Table from "@/assets/comman/Table";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";
import { Separator } from "../ui/separator";
import { cn } from "@/lib/utils";

const HeaderPage = ({ pageTitle, count, view, onViewChange }) => {
  const { t } = useTranslation();

  const showCount =
    typeof count === "number"
      ? Number.isFinite(count)
      : typeof count === "string" && count.trim() !== "" && Number.isFinite(Number(count));

  const countSegment = showCount ? <span>({count})</span> : null;

  const showViewToggle =
    (view === "card" || view === "table") &&
    typeof onViewChange === "function";

  return (
    <div
      className={cn(
        "flex flex-wrap items-center mb-[2rem] w-full gap-4 justify-between",
        showViewToggle && "rtl:flex-row-reverse rtl:justify-between",
      )}
    >
      <h1 className="text-3xl font-bold font-[Dubai] text-[#172038] hover:text-[#172038]/80 capitalize min-w-0 flex-1">
        {pageTitle} {countSegment}
      </h1>
      {showViewToggle && (
        <div className="flex shrink-0 gap-0 px-2 items-center bg-white rounded-full">
          <button
            type="button"
            aria-label={t("common.headerPage.cardView")}
            aria-pressed={view === "card"}
            onClick={() => onViewChange("card")}
            className="flex min-h-10 min-w-10 items-center justify-center rounded-full px-4 py-2 text-[1.25rem] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40"
          >
            <span className="pointer-events-none inline-flex">
              <Cards
                color={
                  view === "card"
                    ? "var(--color-primary)"
                    : "var(--color-neutral-400)"
                }
              />
            </span>
          </button>
          <Separator orientation="vertical" className="!h-9" />
          <button
            type="button"
            aria-label={t("common.headerPage.tableView")}
            aria-pressed={view === "table"}
            onClick={() => onViewChange("table")}
            className="flex min-h-10 min-w-10 items-center justify-center rounded-full px-4 py-2 text-[1.25rem] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40"
          >
            <span className="pointer-events-none inline-flex">
              <Table
                color={
                  view === "table"
                    ? "var(--color-primary)"
                    : "var(--color-neutral-400)"
                }
              />
            </span>
          </button>
        </div>
      )}
    </div>
  );
};

HeaderPage.propTypes = {
  pageTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  view: PropTypes.oneOfType([
    PropTypes.oneOf(["card", "table"]),
    PropTypes.bool,
  ]),
  onViewChange: PropTypes.func,
};

export default HeaderPage;
